<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ boardBasisLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field
              label="Name"
              v-model="bb.name"
              @input="$v.bb.name.$touch()"
              @blur="$v.bb.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              label="Code"
              v-model="bb.code"
              @input="$v.bb.code.$touch()"
              @blur="$v.bb.code.$touch()"
              :error-messages="codeErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col>
            <v-switch
              v-model="bb.notInUse"
              label="Not In Use"
              :outlined="outlinedInputs"
            ></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  BOARD_BASIS_TYPE_UPDATE_MUTATION,
  BOARD_BASIS_TYPE_CREATE_MUTATION,
} from "../../../../constants/graphql";
import { required } from "vuelidate/lib/validators";

export default {
  name: "BoardBasisEditor",

  props: {
    boardBasis: {
      type: Object,
      default: () => ({}),
    },

    doSaveBoardBasis: {
      type: Boolean,
      default: false,
    },

    boardBasisEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      bb: { ...this.boardBasis },
      debug: false,
    };
  },

  methods: {
    saveBoardBasis() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? BOARD_BASIS_TYPE_UPDATE_MUTATION
            : BOARD_BASIS_TYPE_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.bb,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    boardBasisLabel() {
      return this.boardBasis.id != null
        ? this.boardBasis.name
        : "New Board Basis Type";
    },
    context() {
      return this.boardBasis.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.bb.name.$dirty) {
        return errors;
      }
      if (!this.$v.bb.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    codeErrors() {
      let errors = [];
      if (!this.$v.bb.code.$dirty) {
        return errors;
      }
      if (!this.$v.bb.code.required) {
        errors.push("Code is required.");
      }
      return errors;
    },
  },

  watch: {
    boardBasis(data) {
      let boardBasis = { ...data };
      delete boardBasis.__typename;
      this.bb = boardBasis;
    },
    boardBasisEditorDialog(value) {
      if (!value) {
        this.bb = {};
        this.$v.$reset();
      }
    },
    doSaveBoardBasis(value) {
      if (value) {
        this.saveBoardBasis();
      }
    },
  },
  validations: {
    bb: {
      name: { required },
      code: { required },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/BoardBasisEditor.vue